import Button from '@mui/material/Button'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { useGridApiContext } from '@mui/x-data-grid-pro'

declare module '@mui/x-data-grid-pro' {
  interface GridLocaleText {
    resetColumnsButton: string
  }

  interface GridApiPro {
    restoreSettings: () => Promise<void>
  }
}

export function DataGridToolbarColumnsResetButton() {
  const gridApiRef = useGridApiContext()

  const handleClick = async () => {
    await gridApiRef.current.restoreSettings?.()
  }

  return (
    <Button onClick={handleClick} size='small' startIcon={<RestartAltIcon fontSize='inherit' />} variant='text'>
      {gridApiRef.current.getLocaleText('resetColumnsButton')}
    </Button>
  )
}
